import css from 'styled-jsx/css';

const accordionStyles = css`
  .accordion {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: white;
    min-width: 298px;
    border-radius: 8px;
    box-shadow: none;
    flex-grow: 1;
  }

  .accordion-summary {
    padding: 12px 12px 12px 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
    text-transform: uppercase;
    letter-spacing: 0.2px;
    cursor: pointer;
  }

  .collapsed {
    display: none;
  }
`;

export default accordionStyles;
